import React from 'react';
import './liquidacionesModule.css';

const joinClassNames = (...values) => values.filter(Boolean).join(' ');

export function LiquidacionesBtnCrear({ children, className = '', icon = 'fa-plus-circle', ...props }) {
    return (
        <button
            type="button"
            className={joinClassNames('btn btn-sm gestion-liquidaciones-btn-crear', className)}
            {...props}
        >
            {icon && <i className={`fa ${icon} me-1`} aria-hidden="true" />}
            {children}
        </button>
    );
}

export function LiquidacionesBtnBuscar({ children, className = '', icon = 'fa-search', ...props }) {
    return (
        <button
            type={props.type || 'button'}
            className={joinClassNames('btn btn-sm gestion-liquidaciones-btn-buscar', className)}
            {...props}
        >
            {icon && <i className={`fa ${icon} me-1`} aria-hidden="true" />}
            {children}
        </button>
    );
}

export function LiquidacionesBtnLimpiar({ children = 'Limpiar', className = '', ...props }) {
    return (
        <button
            type={props.type || 'button'}
            className={joinClassNames('btn btn-sm gestion-liquidaciones-btn-limpiar', className)}
            {...props}
        >
            {children}
        </button>
    );
}

export function LiquidacionesBtnGuardar({ children, className = '', ...props }) {
    return (
        <button
            type={props.type || 'button'}
            className={joinClassNames('btn btn-sm gestion-liquidaciones-btn-guardar', className)}
            {...props}
        >
            {children}
        </button>
    );
}

export function LiquidacionesBtnCancelar({ children = 'Cancelar', className = '', ...props }) {
    return (
        <button
            type="button"
            className={joinClassNames('btn btn-sm gestion-liquidaciones-btn-cancelar', className)}
            {...props}
        >
            {children}
        </button>
    );
}

export function LiquidacionesEmptyState({ children, className = '' }) {
    return (
        <div className={joinClassNames('gestion-liquidaciones-empty', className)}>
            {children}
        </div>
    );
}
